import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import { Comment, Email, LeaveYourCommentTitle, Name, PostComment, Website } from "../../../../Constants/Constants";
import { LeaveCommentType } from "../../../../Types/CommonComponentsType";

const LeaveComment = ({blogClass}:LeaveCommentType) => {
  return (
    <Col sm="12">
      <div className={`blog-contact ${blogClass}`}>
        <h3>{LeaveYourCommentTitle}</h3>
        <Form className="default-form">
          <Row>
            <Col md="4" sm="4" className="mt-3">
              <div className="form-group">
                <Label>{Name}</Label>
                <Input type="text" placeholder="Enter Your name" required />
              </div>
            </Col>
            <Col md="4" sm="4" className="mt-3">
              <div className="form-group">
                <Label>{Email}</Label>
                <Input type="text" placeholder="Email" required />
              </div>
            </Col>
            <Col md="4" sm="4" className="mt-3">
              <div className="form-group">
                <Label>{Website}</Label>
                <Input type="text" placeholder="Website" required />
              </div>
            </Col>
            <Col xs="12" className="mt-3">
              <div className="form-group">
                <Label>{Comment}</Label>
                <Input type="textarea" placeholder="Write Your Comment" rows={6} />
              </div>
              <div className="form-group">
                <Button color="primary">
                  {PostComment}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Col>
  );
};

export default LeaveComment;
